import BaseApi from './base';

class Configurations extends BaseApi {
    endpoint = 'configurations';
}

export default new Configurations();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/delivery/configuration.js